<!DOCTYPE html>
<html lang="en">

    <head>

        <meta charset="utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
        <meta name="description" content="">
        <meta name="author" content="">

        <title>Dashboard</title>

    </head>

    <body id="page-top">

        <div>
            <app-paciente-menu [comoFunciona]="appComoFunciona" [diferenciasPaciente]="appDiferenciasPaciente"
                [encontrarDoctor]="appEncontrarDoctor" [ventajas]="appVentajas"></app-paciente-menu>
            <app-paciente-home-image></app-paciente-home-image>
            <app-como-funciona #appComoFunciona></app-como-funciona>
            <app-pacientes-public #appVentajas></app-pacientes-public>
            <app-diferencias-paciente #appDiferenciasPaciente></app-diferencias-paciente>
            <app-encontrar-doctor #appEncontrarDoctor></app-encontrar-doctor>
            <app-footer-common></app-footer-common>
        </div>
    </body>

</html>